var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReply = function SvgReply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.287 3.057a.75.75 0 0 0-.817.163L1.72 9.97a.75.75 0 0 0 0 1.06l6.75 6.75a.75.75 0 0 0 1.28-.53v-4.466c2.797.24 8.215 1.834 11.335 7.813a.75.75 0 0 0 1.415-.347c0-5.82-4.517-12.358-12.75-12.733V3.75a.75.75 0 0 0-.463-.693ZM8.25 8.25c0 .414.336.75.75.75 6.172 0 10.095 3.76 11.46 7.936-3.846-4.67-9.095-5.686-11.46-5.686a.75.75 0 0 0-.75.75v3.44L3.31 10.5l4.94-4.94v2.69Z"
  })));
};
export default SvgReply;